import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { ReactNode } from "react";
import { AUTURA_ASPHALT_DARK, smallTableHeaderSx } from "utils";
import { Column } from "types";

type PanelTableSkeletonProps = {
  columns: Column[];
  size?: "small" | "medium";
};

const PanelTableSkeleton = ({
  columns,
  size = "small",
}: PanelTableSkeletonProps): ReactNode => {
  return (
    <Table size={size}>
      <TableHead>
        <TableRow>
          <TableCell
            sx={{ ...smallTableHeaderSx, color: AUTURA_ASPHALT_DARK }}
            colSpan={columns.length}
          >
            {"v"}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(1)].map((_, index) => (
          <TableRow
            key={index}
            sx={{
              background: index % 2 === 0 ? "white" : "whitesmoke",
              cursor: "pointer",
            }}
          >
            {columns.map((column, index) => (
              <TableCell key={`${column.name}${index}`} width={column.width}>
                <Skeleton variant="text" animation={"pulse"} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PanelTableSkeleton;
